module.exports = __webpack_public_path__ + "static/media/Damaged-Your-Car-Get-Cash-For-It-With-FREE-Towing.2f502fef.jpg";